function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStateBlueCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.41,
    height: 27.41,
    viewBox: "0 0 27.41 27.41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 13.7,
    cy: 13.7,
    r: 13.7,
    style: {
      fill: "#5b5bea",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "19.7 8.26 11.23 16.72 7.95 13.46 6.12 15.29 11.23 20.4 21.53 10.09 19.7 8.26",
    style: {
      fill: "#5b5bea",
      strokeWidth: 0
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStateBlueCheck);
export default __webpack_public_path__ + "static/media/state-blue-check.cb2b7064a60bb865f61c1f217460f755.svg";
export { ForwardRef as ReactComponent };